// extracted by mini-css-extract-plugin
module.exports = {"addButton":"TeachersTable_addButton__xVK6j","searchField":"TeachersTable_searchField__2P186"};